import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import "./ConfirmationModal.scss";

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  message: string;
  icon: IconDefinition;
  iconColor: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  title,
  message,
  icon,
  iconColor
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="confirmation-modal">
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <Modal.Title>{title}</Modal.Title>
        <Button variant="link" onClick={onHide} className="close-button">
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center" style={{ whiteSpace: 'pre-wrap' }}>{message}</p>
        <div className="text-center">
          <FontAwesomeIcon icon={icon} className={`${iconColor} fa-3x`} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide} className="mx-auto">
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
